import React from 'react';
import Button from '../Utils/Button';

export default class PlayerBotUserRow extends React.Component
{
  formatDate = ( dateString ) =>
  {
    return new Date( dateString ).toLocaleDateString();
  }

  formatWinPercentage = ( played, won ) =>
  {
    if( played === 0 ) return '0.0%';
    return ( ( won / played ) * 100 ).toFixed( 1 ) + '%';
  }

  getTimezoneDisplay = ( timezone, isAwake ) =>
  {
    const timezoneDisplay = timezone || 'Unknown';
    return (
      <div className="timezone-info">
        <span className="timezone-name">{ timezoneDisplay }</span>
        <span className={ `awake-indicator ${isAwake ? 'awake' : 'asleep'}` }>
          { isAwake ? '🌅 Awake' : '😴 Asleep' }
        </span>
      </div>
    );
  }

  handleViewDetails = () =>
  {
    const { user } = this.props;
    // This would typically navigate to a user detail page
    console.log( 'View user details:', user.username );
  }

  handleViewRoom = ( roomId ) =>
  {
    // This would typically navigate to a room detail page
    console.log( 'View room:', roomId );
  }

  handleSelectChange = ( event ) =>
  {
    const { user, onSelect } = this.props;
    if( onSelect )
    {
      onSelect( user.username, user.userId, event.target.checked );
    }
  }

  render()
  {
    const { user, index, isSelected = false } = this.props;
    const isEvenRow = index % 2 === 0;

    return (
      <div className={ `table-row ${isEvenRow ? 'row-even' : 'row-odd'}` }>
        <div className="col-select">
          <input
            type="checkbox"
            checked={ isSelected }
            onChange={ this.handleSelectChange }
          />
        </div>

        <div className="col-username">
          <span className="username-text">{ user.username }</span>
        </div>

        <div className="col-status">
          <span className={ `status-badge status-${user.status}` }>
            { user.status === 'active' && '🟢 Active' }
            { user.status === 'available' && '🔵 Available' }
            { user.status === 'awake' && '🟡 Awake' }
          </span>
        </div>

        <div className="col-room">
          { user.currentRoomId ? (
            <span
              className="room-link"
              onClick={ () => this.handleViewRoom( user.currentRoomId ) }
            >
              { user.currentRoomId }
            </span>
          ) : (
            <span className="no-room">-</span>
          ) }
        </div>

        <div className="col-timezone">
          { this.getTimezoneDisplay( user.timezone, user.isAwake ) }
        </div>

        <div className="col-games">
          <div className="games-info">
            <span className="games-played">{ user.gamesPlayed } played</span>
            <span className="games-won">{ user.gamesWon } won</span>
            <span className="win-percentage">
              { this.formatWinPercentage( user.gamesPlayed, user.gamesWon ) }
            </span>
          </div>
        </div>

        <div className="col-karma">
          <span className={ `karma-score ${user.karmaScore >= 0 ? 'positive' : 'negative'}` }>
            { user.karmaScore }
          </span>
        </div>

        <div className="col-joined">
          <span className="joined-date">{ this.formatDate( user.joinedDate ) }</span>
        </div>

        <div className="col-actions">
          <Button
            className="view-details-button"
            onClick={ this.handleViewDetails }
          >
            View Details
          </Button>
        </div>
      </div>
    );
  }
}
